module.exports = __webpack_public_path__ + "img/nie-applications-md.b5f24080.png";